import { set } from 'cerebral/factories';
import { state, props } from 'cerebral';

export default path => [set(state`${path}.network.offline`, props`offline`)];
